import React, { useEffect, useState } from "react";
import { HoloCard } from "@/components/Holo";
import api from "@/lib/api";

const KINDS = [
  { k: "all", label: "All" },
  { k: "character", label: "Characters" },
  { k: "product", label: "Products" },
  { k: "scene", label: "Scenes" },
  { k: "render", label: "Renders" },
];

export default function MemoryVault() {
  const [vault, setVault] = useState([]);
  const [gens, setGens] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    Promise.all([api.get("/vault"), api.get("/generations")])
      .then(([v, g]) => { setVault(v.data); setGens(g.data.filter((x) => x.image)); })
      .catch(() => {});
  }, []);

  let items = [];
  if (filter === "render") items = gens.map((g) => ({ id: g.id, name: g.prompt?.slice(0, 30), image: g.image, tag: "RENDER" }));
  else items = vault.filter((v) => filter === "all" || v.kind === filter).map((v) => ({ ...v, tag: v.kind.toUpperCase() }));
  if (filter === "all") items = [...items, ...gens.map((g) => ({ id: g.id, name: g.prompt?.slice(0, 30), image: g.image, tag: "RENDER" }))];

  return (
    <div data-testid="module-memory_vault">
      <div className="mb-8">
        <h1 className="font-display font-bold text-2xl sm:text-3xl">Memory Vault</h1>
        <p className="font-mono-tech text-white/40 text-sm mt-1">Everything you've locked into FUTRA</p>
      </div>
      <div className="flex flex-wrap gap-2 mb-8">
        {KINDS.map((k) => (
          <button key={k.k} onClick={() => setFilter(k.k)} data-testid={`vault-filter-${k.k}`}
            className={`font-mono-tech text-[10px] uppercase tracking-widest px-3 py-1.5 border transition-colors ${filter === k.k ? "border-neon-turquoise text-neon-turquoise" : "border-white/15 text-white/50"}`}>
            {k.label}
          </button>
        ))}
      </div>
      {items.length === 0 ? (
        <div className="font-mono-tech text-white/30 text-sm border border-white/10 border-dashed p-12 text-center">Vault empty. Start creating.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {items.map((it) => (
            <HoloCard key={it.tag + it.id} accent="turquoise" className="overflow-hidden" testid={`vault-cell-${it.id}`}>
              <div className="aspect-square bg-black/40 overflow-hidden">
                {it.image ? <img src={it.image} alt={it.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-white/20 font-mono-tech text-xs">NO IMG</div>}
              </div>
              <div className="p-3">
                <span className="font-mono-tech text-[8px] uppercase tracking-widest text-neon-turquoise">{it.tag}</span>
                <div className="font-display text-xs truncate mt-0.5">{it.name || "Untitled"}</div>
              </div>
            </HoloCard>
          ))}
        </div>
      )}
    </div>
  );
}
